import axios from 'axios'
import { API_BASE_URL } from '../M_Utils/services.config'

const CACHE_KEY = 'favoritesCache'
let listeners = []

function notify() {
    listeners.forEach(fn => fn())
}

function getCache() {
    const raw = sessionStorage.getItem(CACHE_KEY)
    return raw ? JSON.parse(raw) : []
}

function setCache(items) {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(items))
    notify()
}

// Helper para obter a URL base (usa API_BASE_URL.main para evitar hooks)
function getBaseUrl() {
    // Tenta ler do LoadingContext se disponível em sessionStorage
    const storedUrl = sessionStorage.getItem('apiBaseUrl')
    const baseUrl = storedUrl || API_BASE_URL.main
    return baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
}

export const FavoritesCache = {
    // Carregar todos os favoritos do utilizador (1x no login)
    async loadAll() {
        try {
            const userId = localStorage.getItem('userId')
            const url = getBaseUrl() + 'userpreferences/favorites/' + userId
            const response = await axios.get(url)
            const data = response.data

            if (data && !data.name) {
                const items = Array.isArray(data) ? data : data.Items || []
                setCache(items)
                return items
            }
            return []
        } catch (error) {
            console.error('Error loading favorites cache:', error)
            return []
        }
    },

    // Ler da cache filtrado por entityName + pageUrl
    getByPage(entityName, pageUrl) {
        return getCache().filter(f => f.EntityName === entityName && f.PageUrl === pageUrl)
    },

    // Guardar favorito: POST API + adicionar a cache
    async save(favorite) {
        try {
            const url = getBaseUrl() + 'Favorites'
            const response = await axios.post(url, favorite)
            const data = response.data

            if (data && !data.name) {
                const cache = getCache()
                cache.push(data)
                setCache(cache)
                return data
            }
            return data // erro
        } catch (error) {
            console.error('Error saving favorite:', error)
            return error
        }
    },

    // Apagar favorito: DELETE API + remover da cache
    async remove(id) {
        try {
            const url = getBaseUrl() + 'Favorites/' + id
            const response = await axios.delete(url)
            const cache = getCache().filter(f => f.Id !== id)
            setCache(cache)
            return response.data
        } catch (error) {
            console.error('Error removing favorite:', error)
            return error
        }
    },

    // Subscrever a mudancas (para re-render dos componentes)
    subscribe(callback) {
        listeners.push(callback)
        return () => { listeners = listeners.filter(fn => fn !== callback) }
    },

    // Verificar se ja tem cache
    isLoaded() {
        return sessionStorage.getItem(CACHE_KEY) !== null
    }
}

